import { render } from "./DateRange.vue?vue&type=template&id=14474348"
const script = {}
script.render = render

export default script